import {MdArrowOutward} from "react-icons/md";

const socialMediaLinks = [
    {
        name: "Youtube Channel",
        description: "Full course guides, all question types, and expert DET tips.",

        url: "https://www.youtube.com/@detstudy/featured",
        icon: "/social-media-icons/youtube.svg"
    },
    {
        name: "TikTok",
        description: "Fast DET tips, pronunciation boosts, and fun mini lessons.",

        url: "https://www.tiktok.com/@detstudy?is_from_webapp=1&sender_device=pc",
        icon: "/social-media-icons/tiktok.svg"
    },
    {
        name: "Instagram",
        description: "Daily tips, success stories, and quick practice exercises.",

        url: "https://www.instagram.com/detstudynow?igsh=MXI4NnhiaHI4MXE4cw==",
        icon: "/social-media-icons/instagram.svg"
    },
    {
        name: "Blog Posts",
        description: "Full learning guides, updates and blogs in multiple languages.",

        url: "https://blog.detstudy.com/",
        icon: "/social-media-icons/books.svg"
    }

];


export default function SocialMediaSection() {
    return (
        <div
            className="px-[12px] bg-[#F9FAFB] lg:py-[140px] flex justify-center items-center box-border py-[18px] lg:px-[148px]">

            <div className={"flex flex-col gap-[20px] lg:gap-[82px]"}>
                <div className={"flex flex-col gap-[12px] lg:gap-[24px]"}>
                    <p className={"font-semibold text-black text-[24px] lg:text-[48px] leading-[120%] lg:leading-[120%] text-center"}>
                        Find DET Study on
                        <span className={"text-[#0C98FE]"}> Social Media </span>
                    </p>
                </div>
                <div className={"grid-cols-1 lg:grid-cols-4 md:grid-cols-2 gap-[24px] lg:gap-[24px] grid"}>
                    {
                        socialMediaLinks.map((item, index) => (
                            <div key={index}
                                 className={"flex flex-col shadow-md bg-[#F2F4F7] text-center border-[1px] gap-[12px] lg:gap-[16px] p-[32px] rounded-[8px] lg:rounded-[16px]    box-border"}>
                                <img src={item.icon} alt={item.name} className={"w-auto h-[48px] mx-auto"}/>
                                <p className={"font-semibold text-[16px] lg:text-[20px] leading-[120%] lg:leading-[120%] text-black"}>
                                    {item.name}
                                </p>
                                <p className={" text-[12px] lg:text-[16px] leading-[120%] lg:leading-[120%] text-[#374151]"}>
                                    {item.description}
                                </p>
                                <MdArrowOutward
                                    onClick={()=>{
                                        window.open(item.url, '_blank');
                                    }}
                                    className={"self-center text-3xl cursor-pointer mt-[24px]"} />

                            </div>
                        ))
                    }
                </div>

            </div>
        </div>
    )
}